let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hmwx0")).then(() => parcelRequire('dMM4v'));